import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import Base from '../base.entity';
import Deleted from '../deleted/deleted.entity';

@Entity('types')
export default class Type extends Base {
	@PrimaryGeneratedColumn()
	id: number;

	@Column('varchar')
	class_name: string;

	@Column('varchar')
	table_name: string;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	// WARNING: this could cause OOM error on prod! be careful, never access ALL of a type's deleted relations
	@OneToMany((type) => Deleted, (deleted) => deleted.type)
	deleted: Deleted[];

	static rules() {
		return {
			id: Joi.number().integer(),
			class_name: Joi.string().max(100),
			table_name: Joi.string().max(100),
			last_updated_time: Joi.date().allow(null),
		};
	}

	toJSON() {
		return {
			id: this.id,
			class_name: this.class_name,
			table_name: this.table_name,
			last_updated_time: this.last_updated_time,
		};
	}

	assign(props?: GenPartial<Type>) {
		super.assign(props);
		if (props) {
			this.last_updated_time = momentTransformer.from(props.last_updated_time);
		}
	}

	constructor(props?: GenPartial<Type>) {
		super(props);
	}
}
